/**
 * Get trigger parameter shorthand
 * @param {String} name
 * @returns {Map<"name" | "rest", String>}
 */
const getTriggerParameterShorthand = (name) => {
  switch (true) {
    /**
     * Axis
     * @example `(x)`
     */
    case /^(x|y|both)$/.test(name):
      return new Map([
        ["name", "axis"],
        ["rest", name],
      ]);

    /**
     * Target
     * @example `(#nav)`
     */
    case /^(\.|#|parent)/.test(name):
      return new Map([
        ["name", "target"],
        ["rest", name],
      ]);

    /**
     * Start
     * @example `(10%)`
     */
    case /^(\d.*)(%|px)$/.test(name):
      return new Map([
        ["name", "start"],
        ["rest", name],
      ]);

    /**
     * Method
     * @example `(self)`
     */
    case /^(delta|delta-continuous|middle|continuous|self|self-continuous|self-parallax|parallax|facing)/.test(
      name
    ):
      return new Map([
        ["name", "method"],
        ["rest", name],
      ]);

    /**
     * Keep
     * @example `inview(keep)`
     */
    case name === "keep":
      return new Map([
        ["name", "keep"],
        ["rest", name],
      ]);

    /**
     * Toggle mode on click
     * @example `(toggle)`
     */
    case name === "toggle":
      return new Map([
        ["name", "toggle"],
        ["rest", "true"],
      ]);

    /**
     * Default
     */
    default:
      return new Map([
        ["name", ""],
        ["rest", ""],
      ]);
  }
};

export default getTriggerParameterShorthand;
